import styled, { createGlobalStyle } from 'styled-components'
import {
  MetaBar as BaseMetaBar,
  MetaItem as BaseMetaItem,
  MetaLabel as BaseMetaLabel,
  MetaValue as BaseMetaValue,
  DescriptionCard as BaseDescriptionCard,
  DescriptionHeader as BaseDescriptionHeader,
  AboutRoot as BaseAboutRoot,
} from 'domain/feature/hub/company/scouting/VisualizationScreen/components/ScoutingAbout/styles'

const ELEVATION2_SHADOW = '0px 2px 8px 0px #00000029'

export const OpportunityDetailGlobalStyle = createGlobalStyle`
  .hub-startup-opportunity-detail-root {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    align-self: stretch;
    box-sizing: border-box;
  }
`

export const DetailFullPageRoot = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  align-self: stretch;
  box-sizing: border-box;
`

export const DetailPageWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 0px 32px !important;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 30px;
  align-self: stretch;

  @media (max-width: 768px) {
    padding: 0px 16px !important;
  }
`

export const DetailHeader = styled.div`
  width: 100%;

  h2 {
    max-width: 100%;
    white-space: normal;
  }
`

export const DetailContentSection = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;

  > div {
    width: 100%;
    max-width: 100%;
  }

  h2,
  hr {
    max-width: 100% !important;
  }
`

export const DetailBodyGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(clamp(200px, 18.75vw, 240px), auto);
  column-gap: clamp(12px, 1.5vw, 24px);
  row-gap: 0;
  width: 100%;
  align-items: start;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    row-gap: clamp(8px, 1vw, 16px);
  }
`

export const OpportunityDetailMetaBar = styled(BaseMetaBar)`
  height: auto;
  box-sizing: border-box;
  align-items: stretch;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: clamp(12px, 1.2vw, 20px) clamp(16px, 1.8vw, 24px);
  margin-bottom: 0;

  @media (max-width: 992px) {
    grid-row: 1;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`

export const OpportunityDetailMetaItem = styled(BaseMetaItem)`
  justify-content: flex-start;
`

export const OpportunityDetailMetaLabel = styled(BaseMetaLabel)`
  flex-shrink: 0;
`

export const OpportunityDetailMetaValue = styled(BaseMetaValue)`
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  hyphens: auto;
`

export const MetaBarColumn = styled.div`
  min-width: 0;
  width: 100%;
  grid-column: 1;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media (max-width: 992px) {
    display: contents;
  }
`

export const DetailDescriptionColumn = styled(DetailContentSection)`
  margin-top: 0;

  > div {
    gap: 0;
  }

  @media (max-width: 992px) {
    grid-column: 1;
    grid-row: 3;
    margin-top: 10px;
  }
`

export const OpportunityDetailAboutRoot = styled(BaseAboutRoot)`
  gap: 0;
  width: 100%;
  max-width: 100%;
`

export const OpportunityDescriptionCard = styled(BaseDescriptionCard)`
  padding: clamp(12px, 1.4vw, 20px) clamp(16px, 1.8vw, 24px) clamp(16px, 1.8vw, 24px);
  margin-top: 0;
  box-shadow: ${ELEVATION2_SHADOW};
`

export const OpportunityDescriptionHeader = styled(BaseDescriptionHeader)`
  margin-bottom: clamp(8px, 1vw, 12px);
`

export const InterestCardColumn = styled.div`
  grid-column: 2;
  grid-row: 1;
  width: 100%;
  min-width: 0;
  align-self: start;
  display: flex;
  justify-content: flex-start;

  @media (max-width: 992px) {
    grid-column: 1;
    grid-row: 2;
  }
`

export const InterestSidebarCard = styled.div`
  width: clamp(200px, 18.75vw, 240px);
  max-width: 240px;
  height: clamp(132px, 12.3vw, 158px);
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: ${ELEVATION2_SHADOW};
  padding: clamp(12px, 1.25vw, 16px);
  display: flex;
  flex-direction: column;
  gap: clamp(12px, 1.25vw, 16px);
  opacity: 1;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 240px;
    height: auto;
    min-height: clamp(132px, 12.3vw, 158px);
  }
`

export const InterestCardTitle = styled.h3`
  margin: 0;
  font-family: 'Caixa Std', sans-serif;
  font-size: clamp(14px, 1.25vw, 16px);
  font-weight: 700;
  color: #1f2937;
  line-height: 1.25;
`

export const InterestCardDeadline = styled.p`
  margin: 0;
  font-family: 'Caixa Std', sans-serif;
  font-size: clamp(12px, 1.1vw, 14px);
  font-weight: 400;
  color: #374151;
  line-height: 1.35;
  flex: 1;
  min-height: 0;
`

export const InterestButton = styled.button<{ $registered?: boolean }>`
  width: clamp(176px, 16.25vw, 208px);
  max-width: 208px;
  height: clamp(34px, 3.125vw, 40px);
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: ${({ $registered }) => ($registered ? '#7a9ab5' : '#0066b3')};
  color: #ffffff;
  border: none;
  border-radius: 4px;
  padding: clamp(6px, 0.625vw, 8px) clamp(12px, 1.25vw, 16px);
  font-family: 'Caixa Std', sans-serif;
  font-size: clamp(12px, 1.1vw, 14px);
  font-weight: 700 !important;
  line-height: 1;
  cursor: ${({ $registered }) => ($registered ? 'not-allowed' : 'pointer')};
  opacity: ${({ $registered }) => ($registered ? 0.85 : 1)};
  transition: background 0.2s, opacity 0.2s;
  white-space: nowrap;
  margin-top: auto;
  flex-shrink: 0;
  box-sizing: border-box;

  svg {
    font-size: clamp(13px, 1.15vw, 15px);
    flex-shrink: 0;
  }

  &:hover:not([disabled]) {
    background: #004f8a;
  }

  &:disabled {
    cursor: not-allowed;
  }
`
